import React, { useState, useEffect } from "react";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

import InformationData from "./Sections/InformationData";
import TeamT5 from "components/ManualOrder/TeamT5";
import Kinetix from "components/ManualOrder/Kinetix";
import CustomerSubscriptionDetails from "./Sections/CustomerSubscriptionDetails";
import Layout from "./Layout";
import AddCustomerSubscription from "./Sections/AddCustomerSubscription";
import { useSelector } from "react-redux";
import ConfirmOrder from "./Sections/ConfirmOrder";
import OrderSummary from "./Sections/OrderSummary";

export default function SectionsPage() {
	const CSPDashboard = useSelector((state) => state.CSPDashboard);
	const [requestService, setRequestService] = useState("");
	const [requestAccessShow, setRequestAccessShow] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		return function cleanup() {};
	}, []);

	return (
		<div>
			<Header
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/>
			<Layout>
				{!CSPDashboard?.TeamT5Form &&
					!CSPDashboard?.KinetixForm &&
					!CSPDashboard?.CustomerSubscriptionDetails &&
					CSPDashboard?.selectedDialogData &&
					!CSPDashboard?.AddCustomerSubscription && (
						<InformationData
							selectedDialogData={CSPDashboard?.selectedDialogData}
							setRequestAccessShow={setRequestAccessShow}
							setRequestService={setRequestService}
						/>
					)}

				{CSPDashboard?.TeamT5Form && <TeamT5 />}

				{CSPDashboard?.KinetixForm && <Kinetix />}

				{CSPDashboard?.CustomerSubscriptionDetails && (
					<CustomerSubscriptionDetails />
				)}

				{CSPDashboard?.AddCustomerSubscription && <AddCustomerSubscription />}

				{CSPDashboard?.ConfirmOrder && <ConfirmOrder />}

				{CSPDashboard?.OrderSummary && <OrderSummary />}
			</Layout>
		</div>
	);
}
